/**
 * Beskeden et medlem får, når det endnu ikke har en profil i portalen.
 *
 * Personer synkroniseres hertil fra AIKA, så tilstanden opstår for medlemmer, der er oprettet hos
 * Advokatsamfundet, men ikke er nået over endnu (ADV-272). Før ADV-288 kunne portalen ikke se
 * tilstanden: `HentPerson` svarer 200 med et tomt `PersonModel`, som bestod alle guards, og
 * medlemmet fik tomme felter vist frem som sin profil — en blindgyde uden nogen forklaring.
 *
 * Bevidst `alert-info` og `role="status"` og ikke en fejl: det er ikke medlemmets fejl, og der er
 * ikke noget at gøre ved det på siden. "Prøv at genindlæse siden", som resten af portalen skriver,
 * når en forespørgsel fejler, ville være direkte misvisende her — profilen bliver ikke til af at
 * hente siden igen.
 *
 * Hele sætningen står her, så to sider ikke kan komme til at love medlemmet forskellige ting. Kun
 * konsekvensen skifter fra side til side, og den er en `string` og ikke `children`, fordi den skal
 * passe grammatisk ind som ledsætning: "… i portalen, så {konsekvens}."
 */
const ProfilIkkeKlarBesked = ({ konsekvens }: { konsekvens: string }) => (
  <div className="alert alert-info mb-0" role="status">
    Din profil er endnu ikke klar i portalen, så {konsekvens}. Prøv igen senere,
    eller kontakt Advokatsamfundet, hvis problemet varer ved.
  </div>
);

export default ProfilIkkeKlarBesked;
